// Public - Marketing - Homepage - Homepage Hero
// ----------------------
import React, { 
  useState,
  useEffect,
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectPublic, fetchHeroPodcastCategoryIfNeeded } from '../../../features/public/publicSlice'
// routing
//import { Link, } from "react-router-dom";
// smoothscroll
import { HashLink, } from 'react-router-hash-link';
import { useInView } from 'react-intersection-observer';
// Semantic UI
import {
  Segment,
  Container,
  Grid,
  Button,
  Image,
} from "semantic-ui-react";

import ContentAnimatedScroller from './content-animated-scroller';
import { scrollWithOffset } from '../../../layouts/utils';

// styles
import styles from './homepage-hero-scrolling.module.scss';

//images
import svg_iHR_Logo_FullColor from '../../../layouts/images/iheartradio-logo-fullcolor.svg';


export default function HomepageHeroScrolling() {
  const dispatch = useDispatch()
  const { heroPodcastsCategory, } = useSelector(selectPublic);

  // eslint-disable-next-line
  const [animationState, setAnimationState] = useState({
    isPlaying: true
  })

  useEffect(() => {
    if (!heroPodcastsCategory.loading && heroPodcastsCategory.categoryData === null && !heroPodcastsCategory.error) {
      dispatch(fetchHeroPodcastCategoryIfNeeded({categoryID: 132, limit: 5}))
    }
  }, [dispatch, heroPodcastsCategory,])

  const { 
    ref,
    //inView,
    //entry
  } = useInView({
    /* Optional options */
    threshold: 0,
    initialInView: true, //Set the initial value of the inView boolean. This can be used if you expect the element to be in the viewport to start with, and you want to trigger something when it leaves.
    onChange: (inView, entry) => {
      //console.debug('useInView - onChange - inView', {inView,entry});
      if (inView === false) {
        //console.debug('HomepageHeroScrolling - useInView - onChange - inView - pause', {inView,entry});
        setAnimationState(prevState => ({
          ...prevState,
          isPlaying: false,
        }))
      } else {
        //console.debug('HomepageHeroScrolling - useInView - onChange - inView - play', {inView,entry});
        if (!animationState.isPlaying) {
          setAnimationState(prevState => ({
            ...prevState,
            isPlaying: true,
          }))
        }
      }
    }
  });
  
  return (
    <>
      <section className={styles.component_homepage_hero} ref={ref}>
        <Segment basic id={'overview'} className={'variant-2'}>
          {!heroPodcastsCategory.loading && !heroPodcastsCategory.error && heroPodcastsCategory.scrollingData !== null ?
            <>
              <div className={'scrolling-hero'}>
                <div className={'outer-box'}>
                  <div className={'inner-box'}>
                    <Image size={'small'} src={svg_iHR_Logo_FullColor} aria-label={'iHeart Logo Image'} />
                  </div>
                  <div className="face left"></div>
                  <div className="face right"></div>
                  <div className="face top"></div>
                  <div className="face bottom"></div>
                </div>
                {heroPodcastsCategory.scrollingDataShuffled && heroPodcastsCategory.scrollingDataShuffled.length !== 0 ?
                  <ContentAnimatedScroller items={heroPodcastsCategory.scrollingDataShuffled} isPlaying={animationState.isPlaying} />
                :
                  null
                }
              </div>
            </>
          :
            null
          }
          <div className={'main-container'}>
            <Container>
              <Grid stackable columns={'equal'} verticalAlign={'middle'}>
                <Grid.Row>
                  <Grid.Column className={'left-content-column'}>
                    <Segment basic>
                      <h2>Switch to the World's Largest Podcast Network</h2>
                      <Button as={HashLink} primary
                        to={'#import-podcasts'}
                        scroll={el => scrollWithOffset(el, 0, 'parent')}
                        aria-label={'Go to Import Podcasts section'}
                      >
                        Import Your Podcasts
                      </Button>
                      <Button as={HashLink} secondary
                        to={'#learn-more'}
                        scroll={el => scrollWithOffset(el, 58, 'getBoundingClientRect')}
                        aria-label={'Go to Learn More section'}
                      >
                        Learn More
                      </Button>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column only={'computer'}></Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </div>
        </Segment>
      </section>
    </>
  )
}